import axios from "axios"

export const customAxios = axios.create({
  baseURL: "https://1c1xcy4sz1.execute-api.eu-west-3.amazonaws.com/test/beauty",
  timeout: 10000,
})
